export const FETCH_COMPANY_REQUEST = "FETCH_COMPANY_REQUEST";
export const FETCH_COMPANY_SUCCESS = "FETCH_COMPANY_SUCCESS";
export const FETCH_COMPANY_ERROR = "FETCH_COMPANY_ERROR";

export const UPDATE_DEVICE_COMPANY_REQUEST = "UPDATE_DEVICE_COMPANY_REQUEST";
export const UPDATE_DEVICE_COMPANY_ERROR = "UPDATE_DEVICE_COMPANY_ERROR";
